import { schemeColor } from 'shared/assets/styles/scheme-color.style';
import styled, { css } from 'styled-components';

export const IconContainer = styled.span<{ $color?: string | null }>`
  line-height: 62.5%;
  ${({ $color, theme }) =>
    !!$color &&
    css`
      color: ${schemeColor($color, theme)};
    `}
`;
